export default __webpack_public_path__ + "static/media/helmet.335dfc55.svg";